import { makeStyles } from '@mui/styles';

export const useTeamMemberDetailsPageHeaderStyles = makeStyles(() => ({
  root: {
    padding: '3rem 0',
    color: '#ffffff',
    position: 'relative'
  },
  subtitle: {
    display: 'flex',
    color: '#ffffffc4',
    fontSize: '1.175rem',
    minHeight: '1.85rem',
    marginBottom: '5px'
  },
  status: {
    fontSize: '17px'
  },
  info: {
    fontSize: '14px',
    marginBottom: '1rem'
  },
  actionButtonBox: {
    position: 'absolute',
    top: '3rem',
    right: 0
  },
  membershipsLabel: {
    color: '#ffffffc4',
    fontSize: '0.75rem',
    textTransform: 'uppercase' as const,
    letterSpacing: '0.05em',
    marginBottom: '0.5rem'
  },
  membershipRow: {
    fontSize: '14px',
    marginBottom: '0.5rem'
  },
  membershipLink: {
    color: '#ffffff',
    textDecoration: 'underline',
    '&:hover': {
      color: '#ffffffc4'
    }
  },
  membershipStatus: {
    color: '#ffffffc4',
    marginRight: '0.5rem'
  }
}));
